import React, { ReactNode, FC } from "react";

type PropsType = {
  onClick?: () => void;
  className?: string;
  children?: ReactNode;
};

export const GridCell: FC<PropsType> = ({
  onClick,
  className = "",
  children,
}: PropsType) => {
  return (
    <div
      onClick={onClick}
      className={`px-4 py-3 border-b border-secondary-200 transition-colors duration-200 ${className}`}
    >
      {children}
    </div>
  );
};
